/* =========================

  which is name

============================ */
import styled from "styled-components";
import {break_point_sp} from "../../../Styled/mixin";

// コンポーネント
import BtnReset from "../button/BtnReset";
// 各コンテンツ
import Pagenation from "./Pagenation";

import { useSelector } from "react-redux";

/* -------------------------

  component

---------------------------- */
function Question( props ) {
  const count = useSelector((state)=>state.count);

  return (
    <Styled className={`question ${(props.num === count)?"isFadeIn":"isDisplayNone"}`} id={props.id}>

      <div className="p-question">
        <section className="p-question__section--answer p-question__section">
          <div className="p-question__section__inner l-inner--1100">
            <div className="p-question__section__conts">
              {/* タイトル */}
              <div className="p-question__block--title p-question__block">
                <div className="p-question__box--h2 p-question__box c-font_f--km">
                  <p className="txt--count">Q{props.num}</p>
                  <h2 className="title">{props.title}</h2>
                </div>
              </div>
              {/* タイトル */}

              {/* ボタン */}
              <div className="p-question__block--answer p-question__block">
                <div className="p-question__box--btn p-question__box">
                  {props.children}
                </div>
              </div>
              {/* ボタン */}

              {/* ページネーション */}
              <div className="p-question__block--pagenation p-question__block">
                <div className="p-question__box--pagenation p-question__box">
                  <Pagenation num={props.num}></Pagenation>
                </div>
              </div>
              {/* ページネーション */}

              {/* はじめからやり直す */}
              <div className="p-question__block--reset p-question__block">
                <div className="p-question__box--reset p-question__box">
                  <BtnReset></BtnReset>
                </div>
              </div>
              {/* はじめからやり直す */}
            </div>
          </div>
        </section>
      </div>
    </Styled>
  );
}

export default Question;

/* -------------------------

  styled

---------------------------- */
const Styled = styled.div`
  .p-question {
    color: #451700;
    margin: 40px 0 40px 0;
    .p-question__section--answer {
      .p-question__section__inner {
        position: relative;
        padding: 18px 50px 35px 50px;
        background-color: #ffffff;
        border-radius: 20px;
        &::before {
          position: absolute;
          right: 33px;
          bottom: 22px;
          content: "";
          display: block;
          width: 140px;
          height: 102px;
          background-image: url(${process.env.PUBLIC_URL}/assets/img/top/leaf-img01.png);
          background-size: 100% auto;
        }
        .p-question__section__conts {
          .p-question__block--title {
            .p-question__box--h2 {
              text-align: center;
              .txt--count {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 70px;
                height: 70px;
                margin: auto;
                background-image: url(${process.env.PUBLIC_URL}/assets/img/top/p-question/question-img01.png);
                background-repeat: no-repeat;
                background-size: 100% auto;
                color: #ffffff;
                font-size: 3.3rem;
                line-height: 1;
              }
              .title {
                margin-top: 10px;
                font-size: 3.6rem;
              }
            }
          }
          .p-question__block--answer {
            margin-top: 45px;
            .p-question__box--btn {
              display: flex;
              flex-wrap: wrap;
              justify-content: space-around;
              .c-btn_select {
                margin-bottom: 20px;
              }
            }
          }
          .p-question__block--pagenation {
            margin-top: 58px;
          }
          .p-question__block--reset {
            margin-top: 39px;
          }
        }
      }
    }
  }

  
  @media ${break_point_sp} {
    .p-question {
      margin: 5% 3%;
      .p-question__section--answer {
        .p-question__section__inner {
          padding: 5%;
          &::before {
            content: none;
          }
          .p-question__section__conts {
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: 0.1fr 1fr 0.1fr 0.1fr;
            min-height: 80vh;
            .p-question__block--title {
              .p-question__box--h2 {
                .txt--count {
                  width: calc(106 / 750 * 100vw);
                  height: calc(105 / 750 * 100vw);
                  font-size: calc(50 / 750 * 100vw);
                }
                .title {
                  font-size: calc(48 / 750 * 100vw);
                }
              }
            }
            .p-question__block--answer {
              margin-top: 25px;
              .p-question__box--btn {
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 100%;
                .c-btn_select {
                  margin-bottom: 10px;
                  width: 90%;
                }
              }
            }
            .p-question__block--pagenation {
              margin-top: 10px;
            }
            .p-question__block--reset {
              margin-top: 30px;
            }
          }
        }
      }
    }
  }
`;
